import { FaHome, FaComments, FaCamera, FaNewspaper, FaInfoCircle, FaUsers, FaCookieBite, FaEnvelope } from 'react-icons/fa';

const Footer = () => {
  const openCookieSettings = () => {
    // Cookie Consent Einstellungen öffnen
    if (window.CookieConsent) {
      window.CookieConsent.showPreferences();
    }
  };

  return (
    <footer className="bg-gray-900/95 backdrop-blur-lg text-white py-16 mt-16 border-t border-white/10">
      <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
        {/* tivoli12 */}
        <div>
          <h3 className="text-xl font-bold mb-4 text-white flex items-center gap-2">
            tivoli12
          </h3>
          <p className="text-sm text-gray-300 leading-relaxed">
            Das Internetportal www.tivoli12.at ist ein privates und unabhängiges, journalistisches Medium, das seinen Fokus auf die Berichterstattung über den FC Wacker Innsbruck gerichtet hat. Gegründet wurde das tivoli12 magazin im Jahr 2008.
          </p>
        </div>

        {/* Inhalte */}
        <div>
          <h3 className="text-xl font-bold mb-4 text-white flex items-center gap-2">
            Inhalte
          </h3>
          <ul className="space-y-3 text-sm text-gray-300">
            <li>
              <a href="https://tivoli12.at" className="text-white hover:text-primary transition-colors duration-200 flex items-center gap-2">
                <FaHome className="w-4 h-4" /> Startseite
              </a>
            </li>
            <li>
              <a href="/forum" className="text-white hover:text-primary transition-colors duration-200 flex items-center gap-2">
                <FaComments className="w-4 h-4" /> Forum
              </a>
            </li>
            <li>
              <a href="https://tivoli12.at/galerie" className="text-white hover:text-primary transition-colors duration-200 flex items-center gap-2">
                <FaCamera className="w-4 h-4" /> Galerie
              </a>
            </li>
            <li>
              <a href="https://tivoli12.at/pressespiegel-2/" className="text-white hover:text-primary transition-colors duration-200 flex items-center gap-2">
                <FaNewspaper className="w-4 h-4" /> Pressespiegel
              </a>
            </li>
            <li>
              <button 
                onClick={openCookieSettings}
                className="text-white hover:text-primary transition-colors duration-200 flex items-center gap-2 text-left"
              >
                <FaCookieBite className="w-4 h-4" /> Cookie-Einstellungen
              </button>
            </li>
          </ul>
        </div>

        {/* Über uns */}
        <div>
          <h3 className="text-xl font-bold mb-4 text-white flex items-center gap-2">
            Über uns
          </h3>
          <ul className="space-y-3 text-sm text-gray-300">
            <li>
              <a href="/impressum" className="text-white hover:text-primary transition-colors duration-200 flex items-center gap-2">
                <FaInfoCircle className="w-4 h-4" /> Impressum
              </a>
            </li>
            <li>
              <a href="https://tivoli12.at/redaktion/" className="text-white hover:text-primary transition-colors duration-200 flex items-center gap-2">
                <FaUsers className="w-4 h-4" /> Redaktionsteam
              </a>
            </li>
            <li>
              <a href="/datenschutz" className="text-white hover:text-primary transition-colors duration-200 flex items-center gap-2">
                <FaInfoCircle className="w-4 h-4" /> Datenschutzerklärung
              </a>
            </li>
          </ul>
        </div>

        {/* Kontakt */}
        <div>
          <h3 className="text-xl font-bold mb-4 text-white flex items-center gap-2">
            Kontakt
          </h3>
          <p className="text-sm text-gray-300 leading-relaxed mb-4">
            Sollten Sie Anregungen, Fragen oder sonstiges Feedback haben, dann zögern Sie nicht, uns zu kontaktieren:
          </p>
          <a 
            href="mailto:redaktion@tivoli12.at" 
            className="text-white hover:text-primary transition-colors duration-200 font-medium flex items-center gap-2"
          >
            <FaEnvelope className="w-4 h-4" /> redaktion@tivoli12.at
          </a>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-gray-800 mt-12 pt-8">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} tivoli12.at - Alle Rechte vorbehalten
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
